import { gql } from "apollo-boost";
import { Card } from 'components/common/card/Card';
import { getUsers } from 'components/graphql/queries';
import OnlyAdmin from 'components/guards/OnlyAdmin';
import { openModal } from 'components/modal/modules/dispatcher/methods';
import PayoutConfirmation from 'components/platform/card/modules/EventFooterControls/PayoutConfirmation'
import 'highlight.js/styles/a11y-dark.css';
import { RolesSystem } from "lib/enums/RolesSystem.enum";
import PromoterLeaderboard from 'pages/manage/events/detail/PromoterLeaderboard';
import React, { Component } from 'react';
import { Subscription } from "react-apollo";
import Moment from "react-moment";
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router';
import { CardImg, Label, Row } from 'reactstrap';
import Col from 'reactstrap/lib/Col';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UIDucks from 'stores/ducks/UI.duck';
import UserDucks from 'stores/ducks/User.duck';
import Orders from './Orders'
import RevenueGraph from './RevenueGraph';
import TicketBreakdownTable from './TicketBreakdownTable'

import { ContentLoader } from '../../../../components/common/loader/ContentLoader';
import { getEvent, getEventBreakdownFiltered } from '../../../../components/graphql/queries';
import { getTicketBankItemsAsString } from '../../../../components/graphql/queries/ticketBank';
import { stripUriParamsString } from '../../../../lib/utils/helpers';

import DashboardPieCharts from './DashboardPieCharts'
import EndSalesModal from './EndSalesModal'
import EventToolbar from './EventToolbar'


enum TicketBreakDownFilterChannel {
	all = 'all',
	private = 'private',
	public = 'public',
}

interface IEventDetailPageProps {
	dispatch?: any;
	match?: any;
	user: any;
	isOpened?: boolean;
}

/**
 * An event's dashboard. With information filtering based on role of user in the event.
 */
export class EventDetailPage extends Component<
	IEventDetailPageProps,
	{ [label: string]: any }
	> {
	public openModal;
	constructor(props) {
		super(props);
		this.fetchNeededData = this.fetchNeededData.bind(this);
		this.renderTable = this.renderTable.bind(this);
		this.toggleFilter = this.toggleFilter.bind(this);
		this.state = {
			data: [
				{ name: 'Total Private Tickets Sold', value: 0 },
				{ name: 'Total Public Tickets Sold', value: 0 }
			],
			updateString: null,
			updateString2: null,
			updateString3: null,
			updateString4: null,
			updateString5: null,
			promoters: [],
			pieChartKey: false,
			ticketInventory: [],
			isDropdownOpen: false,
			tickets: [],
			filterDropdownOpen: false,
			isLoadingTickets: true,
			loading: false,
			isLoadingTicketInventory: true,
			isLoadingEvent: true,
			event: {
				styling: {
					promoImg: '',
					bgImg: ''
				},
				onSale: true,
				currency: ''
			},
			loadFirst: true,
			searchTerm: '',
			resultFound: false, result: [''],
			checked: false,
			dropdownOpen: false,
			breakdownFilterPromoter: null,
			breakdownFilterChannel: TicketBreakDownFilterChannel.all,
			isHost: false,
			timeInfo: {
				startYear: 0,
				startMonth: 0,
				startDay: 0,
				startHour: 0,
				startMinutes: 0,
				startAMPM: 0,
				endYear: 0,
				endMonth: 0,
				endDay: 0,
				endHour: 0,
				endMinutes: 0,
				endAMPM: 0
			},
			filterStatus: 'All'
		};

		this.handleChange = this.handleChange.bind(this);
		this.dropdownToggle = this.dropdownToggle.bind(this);
		this.handleFilter = this.handleFilter.bind(this);
		this.toggleChart = this.toggleChart.bind(this);
		this.reloadData = this.reloadData.bind(this);
		this.reloadDataOnSales = this.reloadDataOnSales.bind(this);
		this.reloadDataOnCheckin = this.reloadDataOnCheckin.bind(this);
		this.reloadDataOnActivation = this.reloadDataOnActivation.bind(this);
		this.reloadDataOnDecay = this.reloadDataOnDecay.bind(this);
		this.handleRoleChange = this.handleRoleChange.bind(this)
		this.formatNumber = this.formatNumber.bind(this);
		this.payout = this.payout.bind(this);
		this.endSales = this.endSales.bind(this);
	}

	public endSales() {
		const eventId = stripUriParamsString(this.props.match.params.eventId);
		openModal(<EndSalesModal eventId={eventId} ticketInventory={this.state.ticketInventory} />, "End Sales for " + this.state.event.name)
	}
	public handleFilter(obj: string) {
		this.setState({ filterStatus: obj })
	}

	public toggleChart() {
		this.setState({ pieChartKey: !this.state.pieChartKey })
	}

	public toggleFilter() {
		this.setState({
			filterDropdownOpen: !this.state.filterDropdownOpen
		});
	}

	public formatNumber(num) {
		return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	}

	public dropdownToggle = () => {
		this.setState({
			isDropdownOpen: !this.state.isDropdownOpen,
		});
	};
	public componentDidMount() {
		this.fetchNeededData();
		if (!this.props.isOpened) {
			return;
		}
		this.props.dispatch(UIDucks.setAppBar(!this.props.isOpened));
	}

	public payout() {
		openModal(<PayoutConfirmation eventId={stripUriParamsString(this.props.match.params.eventId)} />, 'Payout for event ' + this.state.event.name)
	}

	public reloadDataOnSales(updateReturnVal: number) {
		if (updateReturnVal !== this.state.updateString2) {
			const eventId = stripUriParamsString(this.props.match.params.eventId);
			fetchGraphQL(getEvent(eventId), undefined, {}).then(res => {
				const event = res.event.get || {};
				fetchGraphQL(
					`
				query {
					time {
						findByEventId(id:"${eventId}") {
							startYear
							startMonth
							startDay
							startHour
							startMinutes
							startAMPM
						}
					}
				}
				`).then((time => {
						fetchGraphQL(getTicketBankItemsAsString(), undefined, {
							eventId,
						}).then((resultInventory: any) => {

							const ticketInventory = JSON.parse(resultInventory.ticketBank.getAsString) || [];
							const userInputIds: string[] = []

							ticketInventory.map(item => {
								if (item.promoterId !== undefined && item.promoterId !== null) {
									userInputIds.push(item.promoterId)
								}
							})

							fetchGraphQL(getUsers(), undefined, { ids: userInputIds }).then((team) => {

								if (event.hosts === undefined || event.hosts === null) {
									this.setState({
										event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory, data: [
											{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
											{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
										],
										isLoadingTicketInventory: false, promoters: team.user.findByIds, updateString2: updateReturnVal
									});
								} else {
									if (event.hosts.includes(this.props.user.id) || this.props.user.roles.includes(RolesSystem.ADMIN)) {
										this.setState({
											event, isLoadingEvent: false, isHost: true, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString2: updateReturnVal
										});
									} else {
										this.setState({
											event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString2: updateReturnVal
										});
									}
								}
							})
						}); // End of ticket bank fetch
					}))	// End of time fetch		
			});	// End of event fetch
		}
		return undefined
	}

	public reloadDataOnCheckin(updateReturnVal: number) {
		if (updateReturnVal !== this.state.updateString3) {
			const eventId = stripUriParamsString(this.props.match.params.eventId);
			fetchGraphQL(getEvent(eventId), undefined, {}).then(res => {
				const event = res.event.get || {};
				fetchGraphQL(
					`
				query {
					time {
						findByEventId(id:"${eventId}") {
							startYear
							startMonth
							startDay
							startHour
							startMinutes
							startAMPM
						}
					}
				}
				`).then((time => {

						fetchGraphQL(getTicketBankItemsAsString(), undefined, {
							eventId,
						}).then((resultInventory: any) => {

							const ticketInventory = JSON.parse(resultInventory.ticketBank.getAsString) || [];
							const userInputIds: string[] = []

							ticketInventory.map(item => {
								if (item.promoterId !== undefined && item.promoterId !== null) {
									userInputIds.push(item.promoterId)
								}
							})

							fetchGraphQL(getUsers(), undefined, { ids: userInputIds }).then((team) => {

								if (event.hosts === undefined || event.hosts === null) {
									this.setState({
										event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory, data: [
											{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
											{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
										],
										isLoadingTicketInventory: false, promoters: team.user.findByIds, updateString3: updateReturnVal
									});
								} else {
									if (event.hosts.includes(this.props.user.id) || this.props.user.roles.includes(RolesSystem.ADMIN)) {
										this.setState({
											event, isLoadingEvent: false, isHost: true, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString3: updateReturnVal
										});
									} else {
										this.setState({
											event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString3: updateReturnVal
										});
									}
								}
							})
						}); // End of ticket bank fetch
					}))	// End of time fetch		
			});	// End of event fetch
		}
		return undefined
	}

	public reloadDataOnActivation(updateReturnVal: number) {
		if (updateReturnVal !== this.state.updateString4) {
			const eventId = stripUriParamsString(this.props.match.params.eventId);
			fetchGraphQL(getEvent(eventId), undefined, {}).then(res => {
				const event = res.event.get || {};
				fetchGraphQL(
					`
				query {
					time {
						findByEventId(id:"${eventId}") {
							startYear
							startMonth
							startDay
							startHour
							startMinutes
							startAMPM
						}
					}
				}
				`).then((time => {

						fetchGraphQL(getTicketBankItemsAsString(), undefined, {
							eventId,
						}).then((resultInventory: any) => {

							const ticketInventory = JSON.parse(resultInventory.ticketBank.getAsString) || [];
							const userInputIds: string[] = []

							ticketInventory.map(item => {
								if (item.promoterId !== undefined && item.promoterId !== null) {
									userInputIds.push(item.promoterId)
								}
							})

							fetchGraphQL(getUsers(), undefined, { ids: userInputIds }).then((team) => {

								if (event.hosts === undefined || event.hosts === null) {
									this.setState({
										event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory, data: [
											{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
											{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
										],
										isLoadingTicketInventory: false, promoters: team.user.findByIds, updateString4: updateReturnVal
									});
								} else {
									if (event.hosts.includes(this.props.user.id) || this.props.user.roles.includes(RolesSystem.ADMIN)) {
										this.setState({
											event, isLoadingEvent: false, isHost: true, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString4: updateReturnVal
										});
									} else {
										this.setState({
											event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString4: updateReturnVal
										});
									}
								}
							})
						}); // End of ticket bank fetch
					}))	// End of time fetch		
			});	// End of event fetch
		}
		return undefined
	}

	public reloadDataOnDecay(updateReturnVal: number) {
		if (updateReturnVal !== this.state.updateString5) {
			const eventId = stripUriParamsString(this.props.match.params.eventId);
			fetchGraphQL(getEvent(eventId), undefined, {}).then(res => {
				const event = res.event.get || {};
				fetchGraphQL(
					`
				query {
					time {
						findByEventId(id:"${eventId}") {
							startYear
							startMonth
							startDay
							startHour
							startMinutes
							startAMPM
						}
					}
				}
				`).then((time => {

						fetchGraphQL(getTicketBankItemsAsString(), undefined, {
							eventId,
						}).then((resultInventory: any) => {

							const ticketInventory = JSON.parse(resultInventory.ticketBank.getAsString) || [];
							const userInputIds: string[] = []

							ticketInventory.map(item => {
								if (item.promoterId !== undefined && item.promoterId !== null) {
									userInputIds.push(item.promoterId)
								}
							})

							fetchGraphQL(getUsers(), undefined, { ids: userInputIds }).then((team) => {

								if (event.hosts === undefined || event.hosts === null) {
									this.setState({
										event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory, data: [
											{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
											{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
										],
										isLoadingTicketInventory: false, promoters: team.user.findByIds, updateString5: updateReturnVal
									});
								} else {
									if (event.hosts.includes(this.props.user.id) || this.props.user.roles.includes(RolesSystem.ADMIN)) {
										this.setState({
											event, isLoadingEvent: false, isHost: true, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString5: updateReturnVal
										});
									} else {
										this.setState({
											event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString5: updateReturnVal
										});
									}
								}
							})
						}); // End of ticket bank fetch
					}))	// End of time fetch		
			});	// End of event fetch
		}
		return undefined
	}
	public reloadData(updateReturnVal: number) {
		if (updateReturnVal !== this.state.updateString) {
			const eventId = stripUriParamsString(this.props.match.params.eventId);
			fetchGraphQL(getEvent(eventId), undefined, {}).then(res => {
				const event = res.event.get || {};
				fetchGraphQL(
					`
				query {
					time {
						findByEventId(id:"${eventId}") {
							startYear
							startMonth
							startDay
							startHour
							startMinutes
							startAMPM
						}
					}
				}
				`).then((time => {

						fetchGraphQL(getTicketBankItemsAsString(), undefined, {
							eventId,
						}).then((resultInventory: any) => {

							const ticketInventory = JSON.parse(resultInventory.ticketBank.getAsString) || [];
							const userInputIds: string[] = []

							ticketInventory.map(item => {
								if (item.promoterId !== undefined && item.promoterId !== null) {
									userInputIds.push(item.promoterId)
								}
							})

							fetchGraphQL(getUsers(), undefined, { ids: userInputIds }).then((team) => {
								if (event.hosts === undefined || event.hosts === null) {
									this.setState({
										event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory, data: [
											{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
											{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
										],
										isLoadingTicketInventory: false, promoters: team.user.findByIds, updateString: updateReturnVal
									});
								} else {
									if (event.hosts.includes(this.props.user.id) || this.props.user.roles.includes(RolesSystem.ADMIN)) {
										this.setState({
											event, isLoadingEvent: false, isHost: true, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString: updateReturnVal
										});
									} else {
										this.setState({
											event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory,
											isLoadingTicketInventory: false, data: [
												{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
												{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
											], promoters: team.user.findByIds, updateString: updateReturnVal
										});
									}
								}
							})
						}); // End of ticket bank fetch
					}))	// End of time fetch		
			});	// End of event fetch
		}
		return undefined
	}
	public fetchNeededData() {

		this.setState({ loading: true, isLoadingEvent: true })
		const eventId = stripUriParamsString(this.props.match.params.eventId);

		// for bought counts
		fetchGraphQL(`
			query {
				ticket {
					getByEventIdAsString(eventId:"${eventId}")
				}
			}
			`).then(res => {
			this.setState({ tickets: JSON.parse(res.ticket.getByEventIdAsString) })
		})

		fetchGraphQL(getEvent(eventId), undefined, {}).then(res => {
			const event = res.event.get || {};
			fetchGraphQL(
				`
				query {
					time {
						findByEventId(id:"${eventId}") {
							startYear
							startMonth
							startDay
							startHour
							startMinutes
							startAMPM
						}
					}
				}
				`).then((time => {

					fetchGraphQL(getTicketBankItemsAsString(), undefined, {
						eventId,
					}).then((resultInventory: any) => {

						const ticketInventory = JSON.parse(resultInventory.ticketBank.getAsString) || [];
						const userInputIds: string[] = []

						ticketInventory.map(item => {
							if (item.promoterId !== undefined && item.promoterId !== null) {
								userInputIds.push(item.promoterId)
							} else {
								if (item.accessibleTo !== undefined && item.accessibleTo !== null) {
									item.accessibleTo.map((i) => {
										userInputIds.push(i)
									})
								}
							}
						})

						fetchGraphQL(getUsers(), undefined, { ids: userInputIds }).then((team) => {
							if (event.hosts === undefined || event.hosts === null) {
								this.setState({
									event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory, data: [
										{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
										{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
									],
									isLoadingTicketInventory: false, promoters: team.user.findByIds
								});
							} else {
								if (event.hosts.includes(this.props.user.id) || this.props.user.roles.includes(RolesSystem.ADMIN)) {
									this.setState({
										event, isLoadingEvent: false, isHost: true, timeInfo: time.time.findByEventId, ticketInventory,
										isLoadingTicketInventory: false, data: [
											{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
											{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
										], promoters: team.user.findByIds
									});
								} else {
									this.setState({
										event, isLoadingEvent: false, timeInfo: time.time.findByEventId, ticketInventory,
										isLoadingTicketInventory: false, data: [
											{ name: 'Total Private Tickets Sold', value: Number(event.totalPrivate) },
											{ name: 'Total Public Tickets Sold', value: Number(event.totalPublic) }
										], promoters: team.user.findByIds
									});
								}
							}
						})
					}); // End of ticket bank fetch
				}))	// End of time fetch		
		});	// End of event fetch
	}

	public fetchTicketBank() {
		console.log('')
	}

	public toggle = () => {
		this.setState({
			dropdownOpen: !this.state.dropdownOpen,
		});
	};

	public breakdownFilterChangeChannel = (
		channel: TicketBreakDownFilterChannel,
	) => {
		const eventId = stripUriParamsString(this.props.match.params.eventId);
		fetchGraphQL(
			getEventBreakdownFiltered(eventId, channel),
			undefined,
			{},
		).then(res => {
			const event = res.event.get || {};
			this.setState({
				event: {
					...this.state.event,
					...event,
				},
				isLoadingEvent: false,
				breakdownFilterChannel: channel,
			});
		});
	};

	public handleRoleChange(user: any) {
		this.props.dispatch(UserDucks.setUser(user));
		return undefined;
	}

	public breakdownFilterChangePromoter = (promoterId: string) => {
		const eventId = stripUriParamsString(this.props.match.params.eventId);
		fetchGraphQL(
			getEventBreakdownFiltered(eventId, 'all', promoterId),
			undefined,
			{},
		).then(res => {
			const event = res.event.get || {};
			this.setState({
				event: {
					...this.state.event,
					...event,
				},
				isLoadingEvent: false,
				breakdownFilterChannel: null,
				breakdownFilterPromoter: promoterId,
			});
		});
	};

	public isFilterChannel = (channel: TicketBreakDownFilterChannel) => {
		return this.state.breakdownFilterChannel === channel;
	};

	public isFilterPromoter = (promoterId: string) => {
		return this.state.breakdownFilterPromoter === promoterId;
	};

	public handleChange(checked) {
		if (this.state.checked !== checked) {
			this.setState({ checked });
		}
	}

	public renderTable() {

		if (this.state.isLoadingEvent) {
			return null;
		}

		const eventId = stripUriParamsString(this.props.match.params.eventId);

		// important
		const currency = this.state.event.currency === 'INR' ? 'INR' : 'USD'

		const eventUpdated = gql`
      subscription {
        updatedEvent(eventId:"${eventId}")
      }
			`;

		const eventDeleted = gql`
      subscription {
        eventDeletedNowWhat(eventId:"${eventId}")
      }
			`;

		const roleChange = gql`
      subscription {
        roleChange
      }
			`;

		const ticketPurchase = gql`
      subscription {
        ticketPurchase(eventIds:"${eventId}")
      }
			`;

		const ticketDecayed = gql`
      subscription {
        ticketDecayed(eventIds:"${eventId}")
      }
			`;

		const ticketCheckin = gql`
      subscription {
        ticketCheckin(eventIds:"${eventId}")
      }
			`;

		const ticketActivation = gql`
      subscription {
        ticketActivated(eventIds:"${eventId}")
      }
      `;

		const boxes = {
			cancelled: { count: 0, orders: 0 },
			checkedIn: { count: 0, orders: 0 },
			partiallyCheckedIn: { count: 0, orders: 0 },
			bought: { count: 0, orders: 0 },
			activated: { count: 0, orders: 0 },
		};

		if (this.state.event.ticketCounts !== null && this.state.event.ticketCounts !== undefined) {
			this.state.event.ticketCounts.forEach(t => {
				boxes[t.status] = {
					count: t.count,
					orders: t.orders,
				};
			});
		}

		this.state.tickets.sort((a, b) => {
			return a.updatedAt - b.updatedAt
		})

		const ticketInventory: any[] = this.state.ticketInventory

		const ticketBreakMap: any = {};
		// const temp = [
		// 	{
		// 		_id: "5c93f5fe3a2f1f4366e153bb",
		// 		bought: 1,
		// 		price: 100,
		// 		cancelled: 0,
		// 		checkedIn: 0,
		// 		activated: 0,
		// 		enabled: true,
		// 		createdBy: "5c93e41102081336453d0f63",
		// 		name: "One",
		// 		referral: false,
		// 		quantity: 20,
		// 		eventId: "5c93f5b03a2f1f4366e152c7",
		// 		createdAt: "2019-03-21T20:37:18.529Z",
		// 		updatedAt: "2019-03-21T20:37:44.744Z",
		// 		__v: 0,
		// 		promoterId: '',
		// 		promoter: ''
		// 	}];

		// let bool = false;
		// if (this.props.user.roles.includes(RolesSystem.ADMIN)) {
		// 	// If admin do nothing
		// 	bool = true
		// } else if (this.state.event.hosts !== null && this.state.event.hosts.includes(this.props.user.id)) { // If host
		// 	// If host do nothing 
		// 	bool = true;
		// } else {

		// 	ticketInventory.map((item) => {
		// 		if (item.promoterId === this.props.user.id) {
		// 			temp.push(item);
		// 		}
		// 	})
		// 	temp.splice(0, 1)
		// }

		const ticketBreak: any[] = [];
		for (const key in ticketBreakMap) {
			if (key) {
				ticketBreak.push(ticketBreakMap[key]);
			}
		}

		// Make map based on price
		let bought = 0;
		let free = 0;
		let checkedIn = 0;

		ticketBreak.sort((a, b) => a.price - b.price);
		const { timeInfo } = this.state;

		let promMap = {}
		this.state.promoters.map(item => {
			promMap = {
				...promMap, [item.id]: { name: item.name + ' ' + item.lastname, email: item.email }
			}
		})

		// if (eventId === '5eec25888f4c8f13e0db778c') {
		// bought = 0;
		// checkedIn = 0;
		this.state.tickets.map((item) => {
			if (item !== undefined && item !== null && (item.status === 'bought' || item.status === 'checkedIn' || item.status === 'partiallyCheckedIn')) {
				if (item.totalPrice === 0) {
					free += item.totalCount;
				} else {
					bought += item.totalCount;
				}
				item.ticketComponents.map((i) => {
					checkedIn += i.checkedIn;
				})
			}
		})
		// } 

		let isHostOrAdmin = false;
		if (this.props.user.roles.includes(RolesSystem.ADMIN)) {
			isHostOrAdmin = true;
		} else {
			Object.keys(this.props.user.events).map((key) => {
				if (this.props.user.events[key].id === stripUriParamsString(this.props.match.params.eventId)) {
					if (this.props.user.events[key].roles.includes(RolesSystem.HOST) || this.props.user.events[key].roles.includes(RolesSystem.ADMIN)) {
						isHostOrAdmin = true;
					}
				}
			});
		}

		if (!isHostOrAdmin) {
			this.state.data.splice(0, 1);
		}

		return (
			<div>
				<div>
					<p />
					<Subscription subscription={eventDeleted}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.eventDeletedNowWhat === true) {
								return <Redirect to="/manage/events" />;
							}
							return null;
						}}
					</Subscription>

					<Subscription subscription={ticketActivation}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.ticketActivated !== null) {
								if (data.ticketActivated !== this.state.updateString4) {
									return <img height={0} width={0} onLoad={this.reloadDataOnActivation(data.ticketActivated)} style={{ display: 'none' }} />
								}
								return null;
							}
							return null;
						}}
					</Subscription>

					<Subscription subscription={ticketPurchase}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.ticketPurchase !== null) {
								if (data.ticketPurchase !== this.state.updateString2) {
									return <img height={0} width={0} onLoad={this.reloadDataOnSales(data.ticketPurchase)} style={{ display: 'none' }} />
								}
								return null;
							}
							return null;
						}}
					</Subscription>

					<Subscription subscription={ticketCheckin}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.ticketCheckin !== null) {
								if (data.ticketCheckin !== this.state.updateString3) {
									return <img height={0} width={0} onLoad={this.reloadDataOnCheckin(data.ticketCheckin)} style={{ display: 'none' }} />
								}
								return null;
							}
							return null;
						}}
					</Subscription>

					<Subscription subscription={ticketDecayed}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.ticketDecayed !== null) {
								if (data.ticketDecayed !== this.state.updateString5) {
									return <img height={0} width={0} onLoad={this.reloadDataOnDecay(data.ticketDecayed)} style={{ display: 'none' }} />
								}
								return null;
							}
							return null;
						}}
					</Subscription>

					<Subscription subscription={roleChange}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.roleChange !== null && data.roleChange.length !== 0) {

								const events = {}
								Object.keys(this.props.user.events).map((key) => {
									if (this.props.user.events[key].id === data.roleChange[1]) {
										events[key] = { id: this.props.user.events[key].id, roles: [data.roleChange[2]] }
									} else {
										events[key] = this.props.user.events[key]
									}
								});

								const newUser = {
									...this.props.user,
									events
								}
								this.handleRoleChange(newUser);
								return <Redirect to="/manage/events" />;
							}
							return null;
						}}
					</Subscription>

					<Subscription subscription={eventUpdated}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.updatedEvent !== null) {
								if (data.updateEvent !== this.state.updateString) {
									return <img height={0} width={0} onLoad={this.reloadData(data.updatedEvent)} style={{ display: 'none' }} />
								}
								return null;
							}
							return null;
						}}
					</Subscription>
					<div style={{ height: 'auto' }}>
						<EventToolbar
							eventId={eventId}
							dashboard={true}
							eventName={this.state.event.name}
							userId={this.props.user.id}
						/>
					</div>
					<div className="big-split-768">
						<Row className='maxWidth'>
							<Col style={{ float: 'left', width: '60%' }} className="col-6">
								{
									this.state.event.onSale === false ?
										<div>
											<Card style={{ paddingRight: '10%', paddingLeft: '10%' }}>
												<p><br /></p>
												<h4 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>
													{
														this.state.event.isActive ? 'Event not live.' : 'Event has ended.'
													}
												</h4>
												<p><br /></p>
											</Card>
											<p><br /></p>
										</div>
										: null
								}
								<Card>
									<div style={{ maxHeight: '250px', overflowY: 'hidden' }}>
										<CardImg top={true} width="100%"
											src={
												this.state.event.styling.promoImg
													? this.state.event.styling.promoImg
													: 'https://platform.isotopeticketing.com/landing.png'
											}
											alt="Event Image"
											style={{
												borderTopLeftRadius: '15px',
												borderTopRightRadius: '15px'
											}}
										/>
									</div>
									<div style={{ textAlign: 'center', paddingLeft: '5%', paddingRight: '5%' }}>
										<p>
											<br />
											<h3 className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>
												{this.state.event.name}
											</h3>
											<h6 className='text-gray'>{this.state.event.location}</h6>
											<h6 className='text-gray'>
												{
													String(timeInfo.startMonth) + '.' + String(timeInfo.startDay) + '.' + String(timeInfo.startYear) + ' ' +
													String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))
												}
												{timeInfo.startAMPM ? 'PM' : 'AM'}
											</h6>
										</p>
										<p />
									</div>
								</Card>
								<p><br /></p>
								<TicketBreakdownTable
									loadingTicketInventory={this.state.isLoadingTicketInventory}
									bool={isHostOrAdmin}
									promoters={this.state.promoters}
									ticketInventory={ticketInventory}
									eventId={eventId}
									promMap={promMap}
									// temp={temp}
									isHost={this.state.isHost}
									onSale={this.state.event.onSale}
									currency={currency}
									capacityRemaining={this.state.event.capacityRemaining}
									user={this.props.user}
								/>
								<p><br /></p>
								{/* <Card className='mb-2'>
									<div>
										<p />
										<div>
											<h3 className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'} style={{ width: '100%', textAlign: 'center' }}>Promoter Leaderboard</h3>
											<p />
											<PromoterLeaderboard
												eventId={stripUriParamsString(this.props.match.params.eventId)}
												ticketBank={this.state.ticketInventory} promoters={promMap}
											/>
										</div>
									</div>
									<p />
								</Card>
								<p><br /></p> */}
								<Orders
									eventId={eventId}
									ticketInventory={ticketInventory}
									promMap={promMap}
									isHost={this.state.isHost}
									lastInitialOnly={this.state.event.lastInitialOnly}
									payoutDone={this.state.event.payoutTime === undefined || this.state.event.payoutTime === null ? false : true}
									isHostOrAdmin={isHostOrAdmin}
									onSale={this.state.event.onSale}
									currency={currency}
								/>
							</Col>
							<Col style={{ float: 'right', textAlign: 'center', width: '35%' }} >
								<Card>
									<div>
										<div style={{ textAlign: 'center' }}>
											<p />
											<Label>REVENUE</Label>
											<h2>
												<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>
													{
														currency === 'INR' ? <span>&#8377;</span> : '$'
													}
													{this.formatNumber((Number(this.state.event.revenueTotal) / 100).toFixed(2))}<br />
												</span>
											</h2>
											<p>
												{
													this.state.event.taxTotal !== undefined && this.state.event.taxTotal !== null && Number(this.state.event.taxTotal) !== 0
														?
														<div>
															TAX COLLECTED<br />
															<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>
																{
																	currency === 'INR' ? <span>&#8377;</span> : '$'
																}
																{this.formatNumber((Number(this.state.event.taxTotal) / 100).toFixed(2))}
															</span>
														</div>
														: null
												}
												<OnlyAdmin>
													<div>
														STRIPE FEES<br />
														<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>
															{
																currency === 'INR' ? <span>&#8377;</span> : '$'
															}
															{this.formatNumber((Number(this.state.event.stripeFeeTotal) / 100).toFixed(2))}
														</span>
													</div>
													<div>
														PLATFORM FEES<br />
														<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>
															{
																currency === 'INR' ? <span>&#8377;</span> : '$'
															}
															{this.formatNumber((Number(this.state.event.platFormFeeTotal) / 100).toFixed(2))}
														</span>
													</div>
												</OnlyAdmin>
											</p>
										</div>
										<Row className=' w-auto d-flex p-3' >
											<Col md='4' sm='12' style={{ textAlign: 'center' }}>
												<Label>OFFERS PENDING PURCHASE</Label>
												<h2>
													<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>{boxes.activated.count}{' '}</span>
													<small className='text-gray'> Tickets<br /></small>{' '}
												</h2>
											</Col>
											<Col md='4' sm='12' style={{ textAlign: 'center' }}>
												<Label>BOUGHT</Label>
												<h2>
													<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>{bought}{' '}</span>
													<small className='text-gray'> Tickets<br /></small>{' '}
												</h2>
												<Label>FREE TICKETS</Label>
												<h4>
													<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>{free}{' '}</span>
													<small className='text-gray'> Tickets<br /></small>{' '}
												</h4>
											</Col>
											<Col md='4' sm='12' style={{ textAlign: 'center' }}>
												<Label>CHECKED-IN</Label>
												<h2>
													<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>{checkedIn}{' '}</span>
													<small className='text-gray'> Tickets<br /></small>{' '}
												</h2>
											</Col>
										</Row>
									</div>
								</Card>
								<p><br /></p>
								{
									isHostOrAdmin ?
										<DashboardPieCharts
											eventId={eventId}
											capacity={this.state.event.configuration.quota}
											totalPrivate={this.state.event.totalPrivate}
											totalPublic={this.state.event.totalPublic}
											key={this.state.event.totalPrivate + this.state.event.totalPublic}
										/> : null
								}
								{
									this.state.event.revenueTotal === 0 || this.state.event.revenueTotal === '0' || Number(this.state.event.revenutTotal) === 0 ?
										null :
										<div>
											<RevenueGraph
												isHost={this.state.isHost}
												eventId={stripUriParamsString(this.props.match.params.eventId)}
												onSale={this.state.event.onSale}
												currency={currency}
											/>
											<p><br /></p>
										</div>
								}
								<Card className='mb-2'>
									<div>
										<p />
										<div>
											<h3 className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'} style={{ width: '100%', textAlign: 'center' }}>Promoter Leaderboard</h3>
											<p />
											<PromoterLeaderboard
												eventId={stripUriParamsString(this.props.match.params.eventId)}
												ticketBank={this.state.ticketInventory} promoters={promMap}
											/>
										</div>
									</div>
									<p />
								</Card>
								<p><br /></p>
								{
									this.state.event.isActive && isHostOrAdmin ?
										<div>
											<p style={{ textAlign: 'center', width: '100%' }}>
												<br />
												<button className="new-button-blue-gradient" onClick={this.endSales}>
													End Sales
												</button>
											</p>
										</div> : null
								}
								{
									!this.state.event.isActive && this.state.event.payoutTime === null && this.state.event.revenueTotal !== 0 ?
										<OnlyAdmin>
											<p><br /></p>
											<Card style={{ textAlign: 'center' }}>
												<p />
												{
													this.state.event.payoutTime === null || this.state.event.payoutTime === undefined ?
														<button onClick={this.payout} className="new-button-save"> SEND PAYOUT</button>
														:
														<h5>Payment was sent on <br />
															<strong className="sexyBlack">
																<Moment format="M.D.Y">
																	{this.state.event.payoutTime}
																</Moment>
																{" at "}
																<Moment format="hh:mm A">
																	{this.state.event.payoutTime}
																</Moment>
															</strong>
														</h5>
												}
												<p />
											</Card>
											<p><br /></p>
										</OnlyAdmin> : null
								}
								{
									!this.state.event.isActive && this.state.event.payoutTime !== null && isHostOrAdmin ?
										<div>
											<p><br /></p>
											<Card style={{ textAlign: 'center' }}>
												<p />
												<h5>Payment was sent on <br />
													<strong className="sexyBlack">
														<Moment format="M.D.Y">
															{this.state.event.payoutTime}
														</Moment>
														{" at "}
														<Moment format="hh:mm A">
															{this.state.event.payoutTime}
														</Moment>
													</strong>
												</h5>
												<p />
											</Card>
											<p><br /></p>
										</div>
										: null
								}
							</Col>
						</Row>
					</div>
					<div className="small-split-768">
						<Row className='maxWidth'>
							<Col style={{ float: 'left', width: '100%', paddingRight: '0px', paddingLeft: '0px' }}>
								{
									this.state.event.onSale === false ?
										<div>
											<Card style={{ paddingRight: '10%', paddingLeft: '10%' }}>
												<p><br /></p>
												<h4 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>
													{
														this.state.event.isActive ? 'Event not live.' : 'Event has ended.'
													}
												</h4>
												<p><br /></p>
											</Card>
											<p><br /></p>
										</div>
										: null
								}
								<Card>
									<div style={{ maxHeight: '250px', overflowY: 'hidden' }}>
										<CardImg top={true} width="100%"
											src={
												this.state.event.styling.promoImg
													? this.state.event.styling.promoImg
													: 'https://platform.isotopeticketing.com/landing.png'
											}
											alt="Event Image"
											style={{
												borderTopLeftRadius: '15px',
												borderTopRightRadius: '15px'
											}}
										/>
									</div>
									<div style={{ textAlign: 'center', paddingLeft: '5%', paddingRight: '5%' }}>
										<p>
											<br />
											<h3 className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>
												{this.state.event.name}
											</h3>
											<h6 className='text-gray'>{this.state.event.location}</h6>
											<h6 className='text-gray'>
												{
													String(timeInfo.startMonth) + '.' + String(timeInfo.startDay) + '.' + String(timeInfo.startYear) + ' ' +
													String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))
												}
												{timeInfo.startAMPM ? 'PM' : 'AM'}
											</h6>
										</p>
										<p />
									</div>
								</Card>
								<p><br /></p>
								<Card>
									<div>
										<div style={{ textAlign: 'center' }}>
											<p />
											<Label>REVENUE</Label>
											<h2>
												<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>
													{
														currency === 'INR' ? <span>&#8377;</span> : '$'
													}
													{this.formatNumber((Number(this.state.event.revenueTotal) / 100).toFixed(2))}<br />
												</span>
											</h2>
											<OnlyAdmin>
												<p>
													<div>
														STRIPE FEES<br />
														<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>
															{
																currency === 'INR' ? <span>&#8377;</span> : '$'
															}
															{this.formatNumber((Number(this.state.event.stripeFeeTotal) / 100).toFixed(2))}
														</span>
													</div>
													<div>
														PLATFORM FEES<br />
														<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>
															{
																currency === 'INR' ? <span>&#8377;</span> : '$'
															}
															{this.formatNumber((Number(this.state.event.platFormFeeTotal) / 100).toFixed(2))}
														</span>
													</div>
												</p>
											</OnlyAdmin>
										</div>
										<Row className=' w-auto d-flex p-3' >
											<Col md='4' sm='12' style={{ textAlign: 'center' }}>
												<Label>OFFERS PENDING PURCHASE</Label>
												<h2>
													<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>{boxes.activated.count}{' '}</span>
													<small className='text-gray'> Tickets<br /></small>{' '}
												</h2>
											</Col>
											<Col md='4' sm='12' style={{ textAlign: 'center' }}>
												<Label>BOUGHT</Label>
												<h2>
													<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>{bought}{' '}</span>
													<small className='text-gray'> Tickets<br /></small>{' '}
												</h2>
												<Label>FREE TICKETS</Label>
												<h4>
													<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>{free}{' '}</span>
													<small className='text-gray'> Tickets<br /></small>{' '}
												</h4>
											</Col>
											<Col md='4' sm='12' style={{ textAlign: 'center' }}>
												<Label>CHECKED-IN</Label>
												<h2>
													<span className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'}>{checkedIn}{' '}</span>
													<small className='text-gray'> Tickets<br /></small>{' '}
												</h2>
											</Col>
										</Row>
									</div>
								</Card>
								<p><br /></p>
								{
									isHostOrAdmin ?
										<DashboardPieCharts
											eventId={eventId}
											capacity={this.state.event.configuration.quota}
											totalPrivate={this.state.event.totalPrivate}
											totalPublic={this.state.event.totalPublic}
											key={this.state.event.totalPrivate + this.state.event.totalPublic}
										/> : null
								}
								{
									this.state.event.revenueTotal === 0 || this.state.event.revenueTotal === '0' || Number(this.state.event.revenutTotal) === 0 ?
										null :
										<div>
											<RevenueGraph
												isHost={this.state.isHost}
												eventId={stripUriParamsString(this.props.match.params.eventId)}
												onSale={this.state.event.onSale}
												currency={currency}
											/>
											<p><br /></p>
										</div>
								}
								<TicketBreakdownTable
									loadingTicketInventory={this.state.isLoadingTicketInventory}
									bool={isHostOrAdmin}
									promoters={this.state.promoters}
									ticketInventory={ticketInventory}
									eventId={eventId}
									promMap={promMap}
									// temp={temp}
									isHost={this.state.isHost}
									onSale={this.state.event.onSale}
									currency={currency}
									capacityRemaining={this.state.event.capacityRemaining}
									user={this.props.user}
								/>
								<p><br /></p>
								<Card className='mb-2'>
									<div>
										<p />
										<div>
											<h3 className={this.state.event.onSale ? 'sexyBlack' : 'pause-gray'} style={{ width: '100%', textAlign: 'center' }}>Promoter Leaderboard</h3>
											<p />
											<PromoterLeaderboard
												eventId={stripUriParamsString(this.props.match.params.eventId)}
												ticketBank={this.state.ticketInventory} promoters={promMap}
											/>
										</div>
									</div>
									<p />
								</Card>
								<p><br /></p>
								<Orders
									eventId={eventId}
									ticketInventory={ticketInventory}
									promMap={promMap}
									isHost={this.state.isHost}
									lastInitialOnly={this.state.event.lastInitialOnly}
									payoutDone={this.state.event.payoutTime === undefined || this.state.event.payoutTime === null ? false : true}
									isHostOrAdmin={isHostOrAdmin}
									onSale={this.state.event.onSale}
									currency={currency}
								/>
								{
									this.state.event.isActive && isHostOrAdmin ?
										<div>
											<p style={{ textAlign: 'center', width: '100%' }}>
												<br />
												<button className="new-button-blue-gradient" onClick={this.endSales}>
													End Sales
												</button>
											</p>
										</div> : null
								}
								{
									!this.state.event.isActive && this.state.event.payoutTime === null && this.state.event.revenueTotal !== 0 ?
										<OnlyAdmin>
											<p><br /></p>
											<Card style={{ textAlign: 'center' }}>
												<p />
												{
													this.state.event.payoutTime === null || this.state.event.payoutTime === undefined ?
														<button onClick={this.payout} className="new-button-save"> SEND PAYOUT</button>
														:
														<h5>Payment was sent on <br />
															<strong className="sexyBlack">
																<Moment format="M.D.Y">
																	{this.state.event.payoutTime}
																</Moment>
																{" at "}
																<Moment format="hh:mm A">
																	{this.state.event.payoutTime}
																</Moment>
															</strong>
														</h5>
												}
												<p />
											</Card>
											<p><br /></p>
										</OnlyAdmin> : null
								}
								{
									!this.state.event.isActive && this.state.event.payoutTime !== null && isHostOrAdmin ?
										<div>
											<p><br /></p>
											<Card style={{ textAlign: 'center' }}>
												<p />
												<h5>Payment was sent on <br />
													<strong className="sexyBlack">
														<Moment format="M.D.Y">
															{this.state.event.payoutTime}
														</Moment>
														{" at "}
														<Moment format="hh:mm A">
															{this.state.event.payoutTime}
														</Moment>
													</strong>
												</h5>
												<p />
											</Card>
											<p><br /></p>
										</div>
										: null
								}
							</Col>
						</Row>
					</div>
					<p><br /></p>
				</div >
			</div >
		);
	}

	public render() {
		return (
			<ContentLoader isLoading={this.state.isLoadingEvent}>
				<div className='div_holder_2'>
					{this.renderTable()}
				</div>
			</ContentLoader>
		);
	}
}

const mapStateToProps = state => {
	return {
		isOpened: UIDucks.getIsAppBarOpen(state),
		user: UserDucks.getUser(state)
	};
};

export default withRouter(connect(mapStateToProps)(EventDetailPage));


// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/EventDetail.page.tsx